import { getService } from '@/modules/Service/services'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useParams } from 'react-router-dom'
import Templates from '../../Templates'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Statement = () => {
    const { id: serviceID } = useParams()
    const { data: service, renderState } = useQueryWithHandler({
        queryFn: () => getService(Number(serviceID)),
        queryKey: [QUERY_KEYS.SERVICE_DETAIL, Number(serviceID)],
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    if (!service) return null

    const ServiceTemplate =
        Templates[service?.service_template] || Templates['Blank']

    const Statement =
        //@ts-ignore
        ServiceTemplate?.Statement || Templates['Blank']?.Statement

    return <Statement service={service} />
}

export default Statement
